export default __webpack_public_path__ + "static/media/lux.3ad3ac33.jpg";